import { Pipe, PipeTransform } from '@angular/core';
import { Location } from 'src/app/core/models/project/location.model';

@Pipe({
  name: 'searchLocationAndController'
})
export class SearchLocationAndController implements PipeTransform {

  transform(location: Location[], keyword: string):  Location[] {
      return location.filter((loc: Location) => {
          const lowerKeyword = keyword.toLowerCase();
        return (
            loc.name.toLowerCase().includes(lowerKeyword) || 
            loc.controllers.$values.some(cont => cont.address.toString().toLowerCase().includes(lowerKeyword))
        );
    });
  }

}


